import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { userActions } from "../../store/actions";
import { useNavigate } from "react-router-dom";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
import { TOAST_TIMER } from "../constants";
const navGaurdKeys = ["auth"];
export const useFetch = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(null);
  const hideServiceError = useCallback(() => {
    setIsError(null);
  }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const performAction = useCallback(
    async (url, options) => {
      try {
        setIsLoading(true);
        setIsError(null);
        const response = await fetch(url, options);
        if (!response.ok) {
          if (response.status === 401) {
            const isAuthService = navGaurdKeys.some((key) =>
              url.toLowerCase().includes(key)
            );
            if (!isAuthService) {
              dispatch(userActions.setShowExpiryModal(true));
              throw new Error("Session Expired Please Login");
            }
          }
          if (response.status === 403) {
            navigate(SITE_LINKS_SCHEMA.FORBIDDEN);
            throw new Error("Unauthorized access");
          }
          const contentType = response.headers.get("Content-Type");
          let errorMessage;
          if (contentType && contentType.includes("application/json")) {
            const errorData = await response.json();
            errorMessage =
              errorData.message ||
              errorData.Message ||
              JSON.stringify(errorData);
          } else {
            errorMessage = await response.text();
          }
          throw new Error(`${errorMessage}`);
        }
        if (url.includes("GetFile")) {
          return response;
        } else {
          const responseData = await response.json();
          return responseData;
        }
      } catch (e) {
        setIsError(e.message);
        throw e;
      } finally {
        setIsLoading(false);
        setTimeout(() => {
          setIsError(null);
        }, TOAST_TIMER);
      }
    },
    [dispatch, navigate]
  );
  return {
    isLoading,
    isError,
    hideServiceError,
    performAction,
  };
};
